<template>
  <div class="row">
    <div class="col-xs-10">
      <div class="row">
        <div class="col-xs-4">
          <label class="">Author First name</label>
          <input class="form-control input-sm" v-model="owner.first_name" placeholder="First name" :disabled="disabled"/>
        </div>
        <div class="col-xs-4">
          <label class="">Author Last name</label>
          <input class="form-control input-sm" v-model="owner.last_name" placeholder="Last name" :disabled="disabled" />
        </div>
        <div class="col-xs-4">
          <label class="">Organisation name</label>
          <input class="form-control input-sm" v-model="owner.organisation_name" placeholder="Organisation name" :disabled="disabled"/>
        </div>
      </div>
    </div>
    <div class="col-xs-2" style="margin: 25px 0">
      <button v-if="!disabled" class="btn btn-xs btn-outline btn-danger" v-on:click="removeAuthor($event, index)"><i class="fa fa-remove"></i> Delete</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Owners',
  props: ['owner', 'removeAuthor', 'index', 'disabled']
}
</script>



// WEBPACK FOOTER //
// src/components/Timestamp/Owners.vue